export const USER_EMPTY = '';
export const USER_NOT_REQUESTED = null;
export const MODAL_SIGNUP = 'signup';
export const MODAL_LOGIN = 'login';
